import { outputFieldsError } from '@/containers/agents/record-skill-outputs.util';
import type { CodeConfig, GraphIssue } from '@/types/custom-playbooks';

export function codeSourceError(source: string): string | undefined {
  if (
    typeof source !== 'string' ||
    !source.trim() ||
    Array.from(source).length > 20000 ||
    source.includes('\0') ||
    Array.from(source).some(
      (point) =>
        point.length === 1 &&
        point.charCodeAt(0) >= 0xd800 &&
        point.charCodeAt(0) <= 0xdfff
    )
  )
    return 'Write a function of up to 20,000 characters';
}

export function codeConfigError(config: CodeConfig): string | undefined {
  if (config.language !== 'javascript') return 'Use JavaScript';
  const source = codeSourceError(config.source);
  if (source) return source;
  if (
    !Array.isArray(config.inputs) ||
    !config.inputs.length ||
    config.inputs.length > 30 ||
    new Set(config.inputs).size !== config.inputs.length ||
    config.inputs.some(
      (id) =>
        typeof id !== 'string' ||
        !id.trim() ||
        id.length > 200 ||
        id.startsWith('_') ||
        id.startsWith('run.')
    )
  )
    return 'Pick 1 to 30 different record fields';
  if (config.outputs?.version !== 1 || !config.outputs.fields.length)
    return 'Declare the outputs';
  return outputFieldsError(config.outputs.fields);
}

export function codeIssueText(issue: GraphIssue): string {
  return `${issue.line !== undefined ? `Line ${issue.line}${issue.column !== undefined ? `:${issue.column}` : ''}: ` : ''}${issue.message}`;
}
